import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import LoadertWrapper from './styles/loader.style';

class Loader extends Component {
	constructor(props) {
        super(props);
        this.state={
           
        }
    }

	render() {
		return (
            <LoadertWrapper>
                <div className="loader">
                    <div className="loader-icon-wrapper">
                        <div className="loader-icon"></div>
                    </div>  
                </div>
            </LoadertWrapper>
        )
    }
}

export default connect()(Loader);